var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-1",
    d: "M17 17v4h4v-4zm0-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zM7 17v4h4v-4zm0-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2Zm10-8v4h4V7Zm0-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2ZM7 7v4h4V7Zm0-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-1",
    style: {
      fill: "none"
    },
    d: "M0 0h28v28H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:none}"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)",
    id: "g16",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1,
      clipPath: "url(#clip-path)"
    },
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)",
    id: "g14",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1,
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect12",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1
    },
    d: "M0 0h28v28H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullMembership);
export default __webpack_public_path__ + "static/media/full-membership.4e80b265672e0aeb41fd59f854b533ef.svg";
export { ForwardRef as ReactComponent };